'use strict';
export {DatePickerComponent as DatePicker} from './DatePickerComponent';



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/components/DatePicker/index.js